import { useEffect } from "react";

interface DocumentMeta {
  title: string;
  description?: string;
  keywords?: string;
  canonicalPath?: string;
}

const setMeta = (attr: "name" | "property", key: string, content: string) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export function useDocumentMeta({ title, description, keywords, canonicalPath }: DocumentMeta) {
  useEffect(() => {
    document.title = title;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("property", "og:title", title);

    const base = "https://sevendaddy.cn";
    const href = `${base}${canonicalPath ?? ""}`;
    setMeta("property", "og:url", href);

    let link = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", href);
  }, [title, description, keywords, canonicalPath]);
}